import { render, staticRenderFns } from "./ChatBubble.vue?vue&type=template&id=6595f88c&scoped=true&lang=pug&"
import script from "./ChatBubble.vue?vue&type=script&lang=js&"
export * from "./ChatBubble.vue?vue&type=script&lang=js&"
import style0 from "./ChatBubble.vue?vue&type=style&index=0&id=6595f88c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6595f88c",
  null
  
)

/* custom blocks */
import block0 from "./ChatBubble.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports